// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container {\n  flex-direction: column;\n  justify-content: space-evenly;\n}\n.container .containerImg {\n  max-height: 70px;\n}\n.container .closeBtn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
